module.exports = import("https://esm.sh/@tiptap/extension-youtube@2.4.0");;